import type { FC, ReactNode } from 'react'
import type { AuthFeature } from '@/components/auth/auth-layout'

import Link from 'next/link'

import {
    ArrowLeft,
    KeyRound,
    LogIn,
    Mail
} from 'lucide-react'

/** Side panel points shared by the password recovery pages */
export const recoveryFeatures: AuthFeature[] = [
    { icon: Mail, text: 'Gunakan email pemilik akun' },
    { icon: KeyRound, text: 'Buat kata sandi baru' },
    { icon: LogIn, text: 'Masuk kembali ke akun Anda' }
]

export const BackToLogin: FC = (): ReactNode => {
    return (
        <p className='text-center'>
            <Link
                href='/masuk'
                className='inline-flex items-center gap-2 rounded-md text-[15px] font-bold text-brand-700 outline-none hover:underline focus-visible:ring-4 focus-visible:ring-ring/30'
            >
                <ArrowLeft className='size-4' aria-hidden='true' />
                Kembali ke masuk
            </Link>
        </p>
    )
}
